
export enum WoundsDressingTabType {
  DRESSINGS = '12',
  WOUNDS    = '24',
  IMAGES    = '36'
}

export enum HoursMinutesType {
  ISO_HOURS_MINUTES_SECONDS_FORMAT = 'HH:mm:ss[Z]',
  ISO_HOURS_MINUTES_FORMAT = 'HH:mm',
  TEEN_VALUE = 10
}

export enum DressingStatus {
  PENDING_LIBERATION = 'PENDING_LIBERATION'
}

export interface DomainType {
  description: string;
  valueDomain: string;
}

export interface SearchType {
  description: string;
  id: number;
}

export interface StringType {
  description: string;
  id: string;
}

export interface WoundsResponse {
  admittedInjury?: string;
  allergies?: string;
  classification?: SearchType;
  clinic: SearchType;
  complement?: SearchType;
  diagnosis?: string;
  establishmentCode?: number;
  location?: SearchType;
  medicineAllergy?: string;
  observation?: string;
  painSite?: string;
  physicalPerson?: string;
  previousHistory?: string;
  professional: StringType;
  reasonEndTreatment?: DomainType;
  releaseDate?: string;
  releaseUsername?: string;
  reportedPain?: string;
  sector: SearchType;
  showInactivate?: boolean;
  startDate?: string;
  unknownStart?: string;
  updateDate?: string;
  username?: string;
  whatUsed?: string;
  whoTreated?: string;
  woundDay: number;
  woundId: number;
  woundMonth: number;
  woundShape?: DomainType;
  woundType?: SearchType;
  woundYear: number;
}

export interface WoundsRequest {
  admittedInjury?: string;
  allergies?: string;
  classification?: string;
  clinic: string;
  complement?: string;
  diagnosis?: string;
  establishmentCode?: number;
  location?: string;
  medicineAllergy?: boolean;
  observation?: string;
  painSite?: string;
  physicalPerson?: string;
  previousHistory?: boolean;
  professional: string;
  reasonEndTreatment?: string;
  releaseDate?: string;
  releaseUsername?: string;
  reportedPain?: boolean;
  sector: string;
  startDate?: string;
  unknownStart?: boolean;
  updateDate?: string;
  username?: string;
  whatUsed?: string;
  whoTreated?: string;
  woundDay: number;
  woundId: number;
  woundMonth: number;
  woundShape?: string;
  woundType?: string;
  woundYear: number;
}

export interface DressingsResponse {
  amountNecroticTissue?: number;
  amountNecroticTissueDesc?: string;
  deadSpace?: number;
  deadSpaceDesc?: string;
  degreeOrStage?: number;
  degreeOrStageDesc?: string;
  depth?: number;
  depthCm?: number;
  depthDesc?: string;
  dressingId?: number;
  dressingSize?: number;
  dressingSizeDesc?: string;
  encounterId?: number | string;
  epithelialization?: number;
  epithelializationDesc?: string;
  exudateAmount?: number;
  exudateAmountDesc?: string;
  gangrene?: number;
  gangreneDesc?: string;
  granulationTissue?: number;
  granulationTissueDesc?: string;
  hardeningPeripheralTissue?: number;
  hardeningPeripheralTissueDesc?: string;
  isAllowEditing?: boolean;
  lenghtCm?: number;
  maceration?: number;
  macerationDesc?: string;
  notes?: string;
  painAround?: number;
  painAroundDesc?: string;
  peripheralTissueEdema?: number;
  peripheralTissueEdemaDesc?: string;
  priorityBorder?: number;
  priorityBorderDesc?: string;
  recordDate?: string;
  releaseDate?: string;
  result?: string;
  resultDsScore?: string;
  sector?: SearchType | number
  sectorDesc?: string;
  showInactivate?: boolean;
  size?: number;
  skinColorAroundWound?: number;
  skinColorAroundWoundDesc?: string;
  timeMinutes?: number;
  totalScore?: number;
  typeExudate?: number;
  typeExudateDesc?: string;
  typeNecroticTissue?: number;
  typeNecroticTissueDesc?: string;
  validityHours?: number;
  widthCm?: number;
  woundId?: number;
}

export interface dressingDetailResponse {
  encounterId?: number;
  recordDate?: string;
  releaseDate?: string;
  score?: number;
  showInactivate?: boolean;
}
